import React from 'react';
import Table from './table/Table';
import {observer, inject} from 'mobx-react'
import {cdn} from '../helpers/cdn';

const metadata = {
    icon: cdn('icons/7tv_v1.svg'),
    title: 'Top 7TV Emotes',
    colorPrimary: '#29d8f6',
    colorSecondary: '#4fc2bc',
};

@inject('store') @observer
class SevenTVEmotes extends React.Component {

    render() {
        const {store} = this.props;
        const {items, status} = store.sevenTVEmotes;
        return (
            <Table tableMetadata={metadata} status={status} data={items} tableType="sevenTVEmotes"/>
        );
    }
}

export default SevenTVEmotes;



// WEBPACK FOOTER //
// ./src/app/components/7tvEmotes.js